import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct";

export const projectBirthDate: NgbDateStruct = {
  year: 2018,
  month: 10,
  day: 14,
};

export const userKey = "currentUser";
